/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer, Legend, Label, Tooltip, TooltipProps } from 'recharts';
import { IChart } from 'src/interfaces/chart';

import { Loader, EmptyPieChart } from 'pg-ui-library';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';
import { Container, LegendSpan, TooltipBox } from './styles';

const CustomTooltip = ({ active, payload }: TooltipProps<ValueType, NameType>) => {
  if (active) {
    const name = payload ? payload[0].name : '';

    return (
      <TooltipBox>
        <p className="label">{`${name}`}</p>
      </TooltipBox>
    );
  }

  return null;
};

const LegendFormatter = (value: string) => <LegendSpan>{value}</LegendSpan>;

type ChartProps = IChart & { isLoading: boolean };

const ActiveInactiveEmployeesChart: React.FC<ChartProps> = ({ data, isLoading }) => {
  const employees = data.map(item => item.value);
  const totalEmployees = employees.reduce((add, a) => add + a, 0);

  const empty: boolean = totalEmployees === 0;

  return (
    <Container>
      {isLoading ? (
        <ResponsiveContainer maxHeight={200} width="50%">
          <Loader />
        </ResponsiveContainer>
      ) : (
        <ResponsiveContainer width="60%" maxHeight={200} aspect={2}>
          {!empty ? (
            <PieChart>
              <Legend
                verticalAlign="top"
                align="left"
                layout="vertical"
                iconType="square"
                iconSize={12}
                formatter={LegendFormatter}
              />
              <Tooltip content={<CustomTooltip />} />
              <Pie data={data} dataKey="value" nameKey="name" cx="60%" cy="40%" innerRadius="65%" fill="#8884d8">
                {data.map((entry, index) => (
                  <Cell key={index} fill={entry.color} />
                ))}
                <Label
                  value={`Total: ${totalEmployees}`}
                  position="center"
                  fill="#1A1A32"
                  fontFamily="BiotifMedium"
                  fontSize={15}
                />
              </Pie>
            </PieChart>
          ) : (
            <EmptyPieChart />
          )}
        </ResponsiveContainer>
      )}
    </Container>
  );
};

export default ActiveInactiveEmployeesChart;
